import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=4056697f&"
import script from "./servers.vue?vue&type=script&lang=js&"
export * from "./servers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports